module.exports = __webpack_public_path__ + "img/withdrawal-failed.5e2c5676.svg";